import React from "react"
import LaborAccessRequestProviderExternal from "../../components/LaborAccessRequest/LaborAccessRequestProviderExternal"


function LaborAccessRequestProviderExternalPage() {
  return <LaborAccessRequestProviderExternal />
}

export default LaborAccessRequestProviderExternalPage
